import {z} from "zod/v4";

export const TieredOrActive = z.enum(["tiered", "active"]);
export type TieredOrActive = z.infer<typeof TieredOrActive>;